module.exports = __webpack_public_path__ + "img/6.39be0d5e.jpg";